<script>
import axios from 'axios';
import numeral from 'numeral';

export default {
    data() {
        return {
            rangkumanTagihan: null,

            isLoading: false,
            tableHeaders: [
                { text: 'Nama Tagihan', value: 'nama_tagihan' },
                { text: 'Semester', value: 'semester' },
                { text: 'Periode', value: 'periode' },
                { text: 'Batas Pembayaran', value: 'batas_pembayaran' },
                { text: 'Nominal', value: 'nominal' },
                { text: 'Terbayar', value: 'terbayar' },
            ],
            tableItems: [],
            options: {},
            pagination: {
                currentPage: 1,
                lastPage: 0,
                perPage: 0,
                total: 0
            },
        }
    },
    mounted() {
        this.fetchData();
    },
    filters: {
        formatNumber(value) {
            return `Rp ${numeral(value).format('0, 0')}`;
        }
    },
    methods: {
        fetchData() {
            this.isLoading = true;

            const endpoint = `${process.env.VUE_APP_ROOT_API}/api/ortu/tagihan`
            const { page = 1, itemsPerPage = 10 } = this.options;
            axios.get(endpoint, {
                params: { page }
            })
                .then((response) => {
                    this.rangkumanTagihan = response.data.rangkuman;

                    const tagihan = response.data.tagihan;
                    this.tableItems = tagihan.data.map((item) => ({
                        nama_tagihan: item.nama_tagihan,
                        semester: item.semester,
                        periode: `${item.nama_semester} ${item.tahun_ajaran}`,
                        batas_pembayaran: item.batas_pembayaran,
                        nominal: `Rp ${numeral(item.nominal).format('0,0')}`,
                        terbayar: `Rp ${numeral(item.terbayar).format('0,0')}`
                    }));

                    this.pagination.currentPage = tagihan.current_page;
                    this.pagination.lastPage = tagihan.last_page;
                    this.pagination.perPage = tagihan.per_page;
                    this.pagination.total = tagihan.total;
                })
                .catch((error) => {

                })
                .finally(() => {
                    this.isLoading = false;
                })
        },

        onOptionsChanged(newOptions) {
            const { page, itemsPerPage } = newOptions;

            const pageChanged = page !== this.options.page;
            const perPageChanged = itemsPerPage !== this.options.itemsPerPage;

            this.options = { ...newOptions };

            if (pageChanged || perPageChanged) {
                this.fetchData();
            }
        },

        onPageChanged() {
            this.options.page = this.pagination.currentPage;
            this.fetchData();
        }
    }
}

</script>

<template>
    <div class="daftar-tagihan-container">
        <div v-if="rangkumanTagihan != null" class="alert alert-info border-0">
            Total Tagihan: <span class="fw-bold">{{ rangkumanTagihan.total_tagihan | formatNumber }}</span>
        </div>

        <div class="border-start border-3 border-info px-2 py-1">
            Untuk saat ini, transaksi pembayaran hanya dapat dilakukan 
            di <a href="https://keuportal.utdi.ac.id" class="text-decoration-none">Keuportal UTDI</a> (menggunakan Virtual Account) 
            atau melalui loket keuangan.
        </div>

        <v-data-table 
            :loading="isLoading" 
            :headers="tableHeaders" 
            :items="tableItems" 
            :options.sync="options"            
            :page="pagination.currentPage" 
            :pageCount="pagination.lastPage" 
            :items-per-page="pagination.perPage"
            :server-items-length="pagination.total" 
            @update:options="onOptionsChanged" 
            hide-default-footer
            class="elevation-1">
        </v-data-table>

        <v-pagination v-model="pagination.currentPage" :length="pagination.lastPage" @input="onPageChanged" />
    </div>
</template>